import styled from "@emotion/styled";

type StyledProps = {
  $isEnableTextOverflowEllipsis: boolean;
};

const Container = styled.h3<StyledProps>`
  word-break: break-word;

  ${props =>
    props.$isEnableTextOverflowEllipsis
      ? `
        display: -webkit-box;

        text-overflow: ellipsis;

        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        line-clamp: 3;
      `
      : null}
`;

export const H2Container = Container.withComponent("h2");
export const H3Container = Container.withComponent("h3");
